// extracted by mini-css-extract-plugin
export default {"list":"styles_list__yUQJH","listItem":"styles_listItem__0R+LS"};